<script>
export default {
  name: 'CpBannerFooter',
  directives: {
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
  },
  components: {
    CpButtonLink: require('../../button-link').default,
  },
};
</script>

<template>
  <div class="container">
    <div>
      <img src="https://assets.staging.crowdblue.com/v2/demo/all/img/homepage/footer-banner.png" class="img-banner" loading="lazy" />
    </div>
    <div class="banner-container">
      <h3 class="title-2 primary-color text-left">
        Organize, connect, and discover a community built for changemakers
      </h3>
      <p class="content-2 primary-color text-left" v-margin-top="0">Where your campaign, your voice, and your values belong</p>
      <div class="button-container">
        <CpButtonLink href="/feed" primary block v-margin-right="$root.isMobile ? 0 : 0.5" style="color: var(--white); padding: 0 !important">Continue to the Feed</CpButtonLink>
        <CpButtonLink href="/user/login?create" block style="color: var(--primary); padding: 0 !important" class="plausible-event-name=Account+Process+Started">Sign up</CpButtonLink>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  width: 100%;
  border-radius: var(--external-border-radius);
  background: linear-gradient(90deg, rgba(229, 236, 245, 0) 35.7%, #e5ecf5 48.06%, var(--primary-1) 100%);
}
.banner-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 650px;
  padding: 0 16px 16px 5em;
}
.banner-container h3 {
  font-size: 39px;
}
.img-banner {
  width: 100%;
  height: 100%;
  max-height: 300px;
  object-fit: cover;
  opacity: 0.7;
  border-radius: 16px 0 0 16px;
}
.button-container {
  display: flex;
}
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    max-width: 75%;
    padding: 0;
    background: linear-gradient(0deg, var(--primary-1), var(--primary-1)), linear-gradient(360deg, var(--primary-1) 24.98%, #e5ecf5 64.89%, rgba(229, 236, 245, 0) 101.08%);
  }
  .banner-container {
    align-items: center;
    padding: 0 16px 32px 16px;
  }
  .banner-container h3,
  .banner-container p {
    text-align: center;
  }
  .banner-container h3 {
    font-size: 28px;
  }
  .img-banner {
    border-radius: 16px 16px 0 0;
    max-height: 200px;
  }
  .button-container {
    flex-direction: column;
    width: 100%;
  }
  .button-container a:first-child {
    margin-bottom: 12px;
  }
}
@media screen and (max-width: 600px) {
  .container {
    max-width: 100%;
  }
}
</style>
